import styled, { createGlobalStyle } from "styled-components";

export const FloatingLogChartDialogStyles = createGlobalStyle`
  .log-chart-floating-dialog {
    display: flex;
    flex-direction: column;
    min-width: min(520px, calc(100vw - 1rem));
    max-width: calc(100vw - 1rem);
    max-height: calc(100vh - 1rem);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.16);
  }

  .log-chart-floating-dialog:not(.p-dialog-maximized) {
    margin-left: var(--dialog-offset, 0px);
    margin-top: var(--dialog-offset, 0px);
  }

  .log-chart-floating-dialog .p-dialog-header {
    padding: 0.5rem 0.75rem;
    border-bottom: 1px solid ${({ theme }) => theme.colors.borderColor};
    background: ${({ theme }) => theme.colors.background};
    color: ${({ theme }) => theme.colors.textSecondary};
  }

  .log-chart-floating-dialog .p-dialog-content {
    flex: 1;
    min-height: 0;
    background: ${({ theme }) => theme.colors.background};
  }

  .log-chart-floating-dialog.p-dialog-maximized {
    top: 0 !important;
    left: 0 !important;
    width: 100vw !important;
    height: 100vh !important;
    max-width: 100vw !important;
    max-height: 100vh;
    margin: 0 !important;
    transform: none !important;
    border-radius: 0;
  }

  .log-chart-floating-dialog.p-dialog-maximized .p-dialog-content {
    flex: 1;
    height: auto !important;
  }
`;

export const ChartDialogContent = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.background};

  > div {
    height: 100%;
    min-height: 100%;
  }

  @media screen and (max-width: 900px) {
    width: calc(100vw - 1rem);
    height: 60vh;
    min-width: 0;
  }
`;
